import * as React from "react";
import { Mutation } from "react-apollo";
import { Form, Label, FormGroup, Input, Button } from "reactstrap";
import ReactPhoneInput from "react-phone-input-2";

// GraphQL
import UpdateUserMutation from "../../GraphQL/Mutations/UpdateUser";
import GetCompanyUsers from "../../GraphQL/Queries/GetCompanyUsers";

// Presentation/UI
import Loader from "../../Components/Loader";
import FormCheckbox from "../../Components/FormElements/FormCheckbox";

// Theme
import { Colors } from "../../Themes";

interface IProps {
  companyId: any;
  user: any;
  closeModal(): void;
  notification(message: string): void;
}

interface IState {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  jobTitle: string;
  isATechnician: boolean;
  loading: boolean;
  error: null | string;
}

class EditUserForm extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      id: props.user.id,
      firstName: !props.user.firstName ? "" : props.user.firstName,
      lastName: !props.user.lastName ? "" : props.user.lastName,
      email: props.user.email,
      phoneNumber: !props.user.phoneNumber ? "" : props.user.phoneNumber,
      jobTitle: props.user.jobTitle,
      isATechnician: props.user.isATechnician,
      loading: false,
      error: null
    };
  }

  // Handle change
  handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    const { name, value }: { name: string; value: string } = e.currentTarget;

    switch (name) {
      case "firstName":
        this.setState({ firstName: value });
        break;
      case "lastName":
        this.setState({ lastName: value });
        break;
      case "email":
        this.setState({ email: value });
      case "jobTitle":
        this.setState({ jobTitle: value });
        break;
      default:
        break;
    }
  };

  validateForm = (): boolean => {
    const { firstName, lastName, email, phoneNumber } = this.state;
    // Check for undefined or empty infput fields
    if (!firstName || !lastName || !email || !phoneNumber) {
      this.setError("Please fill in the fields");
      return false;
    }
    return true;
  };

  // Error
  setError = (error: string): void => {
    this.setState(
      {
        error
      },
      () => {
        setTimeout(() => {
          this.setState({ error: null });
        }, 3000);
      }
    );
  };

  isATechnician = (e: React.FormEvent<HTMLInputElement>) => {
    e.preventDefault();
    this.setState({ isATechnician: !this.state.isATechnician });
  };

  render() {
    const {
      id,
      firstName,
      lastName,
      email,
      phoneNumber,
      jobTitle,
      isATechnician
    } = this.state;
    const { companyId, closeModal, notification } = this.props;
    return (
      <Mutation<{}, {}> mutation={UpdateUserMutation}>
        {(updateUser, { loading, error }) => (
          <Form
            onSubmit={e => {
              e.preventDefault();
              if (this.validateForm()) {
                this.setState({ loading: true });

                updateUser({
                  variables: {
                    id,
                    firstName,
                    lastName,
                    phoneNumber,
                    email,
                    jobTitle,
                    isATechnician
                  },
                  refetchQueries: [
                    {
                      query: GetCompanyUsers,
                      variables: { id: companyId }
                    }
                  ]
                })
                  .then(res => {
                    this.setState({ loading: false });

                    closeModal();
                    notification("User updated successfully");
                  })
                  .catch(err => {
                    this.setState({ loading: false });
                  });
              }
            }}
          >
            <FormGroup>
              <Label for="firstName">First Name</Label>
              <Input
                type="text"
                name="firstName"
                value={firstName}
                id="firstName"
                placeholder="First name"
                onChange={this.handleChange}
              />
            </FormGroup>
            <FormGroup>
              <Label for="lastName">Last Name</Label>
              <Input
                type="text"
                name="lastName"
                value={lastName}
                id="lastName"
                placeholder="Last name"
                onChange={this.handleChange}
              />
            </FormGroup>
            <FormGroup>
              <Label for="email">Email Address</Label>
              <Input
                type="email"
                name="email"
                value={email}
                id="email"
                placeholder="Email"
                onChange={this.handleChange}
              />
            </FormGroup>
            <FormGroup>
              <Label for="jobTitle">Job Title</Label>
              <Input
                type="text"
                name="jobTitle"
                value={jobTitle}
                id="jobTitle"
                placeholder="Job title"
                onChange={this.handleChange}
              />
            </FormGroup>
            <FormGroup>
              <Label>Phone Number</Label>
              <ReactPhoneInput
                value={phoneNumber}
                defaultCountry={"za"}
                onChange={(userPhoneNumber: any) =>
                  this.setState({ phoneNumber: userPhoneNumber })
                }
              />
            </FormGroup>
            <FormGroup>
              <Label>Is The User A Technician?</Label>
              <FormCheckbox
                name="isATechnician"
                checked={isATechnician}
                label={!isATechnician ? "No" : "Yes"}
                htmlFor={`isATechnician`}
                inlineStyling={{
                  paddingLeft: "0px",
                  paddingRight: "0px",
                  paddingTop: "5px",
                  paddingBottom: "5px"
                }}
                onChange={(e: React.FormEvent<HTMLInputElement>) =>
                  this.isATechnician(e)
                }
              />
            </FormGroup>
            <br />
            <FormGroup>
              <Button>
                {!this.state.loading ? <span>Update</span> : <Loader />}
              </Button>
            </FormGroup>
            {this.state.error && (
              <p style={{ textAlign: "center", color: Colors.error }}>
                {this.state.error}
              </p>
            )}
          </Form>
        )}
      </Mutation>
    );
  }
}

export default EditUserForm;



// WEBPACK FOOTER //
// ./src/Containers/Users/EditUserForm.tsx